/**
 * pcl-global-footer - Class
 */

// document.addEventListener("DOMContentLoaded", (event) => {
//     let endpoint = $aemEnvURL +'/content/experience-fragments/princess/language-masters/en/footer/master/jcr:content.footer.json';
//     const locale = (window.localeData?.status)?.toLowerCase() || 'us';
//     const aemLocaleString = `en-${locale}`;
//     function renderAEMFooter() {
//         fetch(`${endpoint}?locale=${aemLocaleString}&keys=share`).then(response=>{
//             let res = response.json();
//             return res;
//         }).then(data=>{
//             let template = document.querySelector("pcl-global-footer");
//             if(template){
//                 template.innerHTML = /*html*/`
//                 <link rel="stylesheet" href="${data.cssLibs[0]}" />
//                 <script type="text/javascript" src="${data.jsLibs[0]}"></script>

//             <div id="external-footer">
//                 ${data.content}
//             </div>
//         `;
//             }
//         return template;
//         });
//     }

//     renderAEMFooter();
// });

class PclGlobalFooter extends HTMLElement {
  constructor() {
      super();
      this.render();
      this.currentYear = new Date().getFullYear();
      this.footer$;
  }

  render() {
      this.locale = (window.localeData?.status)?.toLowerCase() || 'in';
      let cmsUtilityLinks;
      let categories;

      Promise.all([
          fetch(`${$wwwURL}/static/html/global/nav/wc/copyright.json`),
          fetch(`${$wwwURL}/static/html/global/nav/wc/footer.json`)
      ]).then((responses) => {
          return Promise.all(responses.map((response) => {
              return response.json();
          }));
      }).then((data) => {
          const copyrightJson = data[0];
          const footerJson = data[1];

          cmsUtilityLinks = copyrightJson ? copyrightJson[0]?.categories : [];
          categories = footerJson ? footerJson[0]?.categories : [] || [];
          const updatedCategoriesObj = {};
          for (let category of categories) {
              const sortOrder = parseInt(category.sortOrder);
              if (updatedCategoriesObj[sortOrder]) {
                  updatedCategoriesObj[sortOrder].push(category);
              } else {
                  updatedCategoriesObj[sortOrder] = [category];
              }
          }
          const template = this.buildTemplate(Object.values(updatedCategoriesObj), cmsUtilityLinks);
          this.attachShadow({ mode: "open" }).appendChild(
              template.content.cloneNode(true)
          );

          // Init Element & Variables
          this.footer$ = this.shadowRoot.querySelector(".global-footer");

          if(this.getAttribute('min-width')) {
              this.shadowRoot.querySelector('footer').style.minWidth = this.getAttribute('min-width');
              this.shadowRoot.querySelector('.footer__social').style.minWidth = this.getAttribute('min-width');
          }
      });
  }

  /**
   * createFooterNavItem
   * @param {object} footerNavItem - data object for footer navigation item to be rendered
   * return {DocumentFragment} template - html markup for footer nav item
   */
  createFooterNavItem(footerNavItem) {
      return /*html*/`
          <div class="footer-navigation__column">
              <h2 class="footer-navigation__column--title">${footerNavItem.name}</h2>
              <ul aria-label="${footerNavItem.name}" class="footer-navigation__column--list no-list-style">
                  ${footerNavItem.navlinks.map((navLink) => this.createNavLink(navLink)).join('')}
              </ul>
          </div>
      `;
  }

  /**
   * createNavLink
   * @param {object} navLink - data object for current link to be rendered
   * return {DocumentFragment} template - html markup for current link
   */
  createNavLink(navLink) {
      const attributes = [`data-${this.locale}-url`, `data-${this.locale}-text`];
      const attributesData = window.getAttributesFromLink(navLink?.localizedLink, attributes);
      return /*html*/`
          ${attributesData[0] ? `
              <li class="footer-navigation__column--list-item">
                  <a class="footer-navigation__column--link invert-decoration" 
                      data-track="footer"
                      data-track-id="${window.convertStringToKebabCase(navLink.title)}"
                      ${navLink?.localizedLink || ''}
                      href="${attributesData[0] || navLink.url}">
                          ${attributesData[1] || navLink.title}
                  </a>
               </li>`
              : `
              <li class="footer-navigation__column--list-item">
                  <a class="footer-navigation__column--link invert-decoration ${navLink?.styleClass}" 
                      data-track="footer" 
                      data-track-id="${window.convertStringToKebabCase(navLink.title)}" 
                      ${navLink?.localizedLink || ''}
                      href="${navLink.url}">
                          ${navLink.title}
                  </a>
              </li>
          `
          }
      `;
  }

  /**
   * createNavAppLinks
   * return {DocumentFragment} template - html markup for App icons Android, Apple.
   */
  createNavAppLinks() {
      return `
          <div class="footer-navigation__app-section">
              <span class="footer-navigation__app-section-title">Princess® Cruises App</span>
              <div class="footer-navigation__app-icons">
                  <div class="footer-navigation__icon">
                      <a class="footer-navigation__icon-apple"
                      href="https://apps.apple.com/us/app/princess-cruises/id6469049279"
                      target="_blank" 
                      rel="noopener noreferrer">
                      <img class="img-responsive" 
                      title="" 
                      alt="Princess Cruises App, download on the Apple App Store. Opens in new tab."
                      src="${$wwwURL}/static/images/global/shared/app-store-badges/badge-app-store-286x88.png">
                      </a>
                  </div>
                  <div class="footer-navigation__icon">
                      <a class="footer-navigation__icon-android"
                      href="https://play.google.com/store/apps/details?id=com.carnival.gxi.princesscruises"
                      target="_blank" 
                      rel="noopener noreferrer">
                      <img 
                      class="img-responsive"
                      title="" 
                      alt="Princess Cruises App, get it on Google Play. Opens in new tab."
                      src="${$wwwURL}/static/images/global/shared/app-store-badges/badge-google-play-286x88.png">
                      </a>
                  </div>
              </div>
          </div>
      `;
  }

  /**
   * createSocialIcons
   * return {DocumentFragment} template
   */
  createSocialIcons() {
      return `
          <div class="footer__social">
              <span>Follow Us:</span>
              <div class="footer__social--icons">
                  <a aria-label="Follow Princess on Facebook." href="https://www.facebook.com/PrincessCruises" rel="noopener noreferrer">
                          <svg id="icon-facebook" xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24"><title>facebook</title><path d="M17.607,4.656H15.534c-1.646,0-1.95.792-1.95,1.889v2.5h3.9v3.9H13.647V23H9.625V12.945H6.271v-3.9H9.623V6.18C9.623,2.827,11.7,1,14.682,1h3.047l-.122,3.656Z" fill="#00538b"/></svg>
                  </a>
                  <a aria-label="Follow Princess on Twitter." href="https://twitter.com/PrincessCruises" rel="noopener noreferrer">
                      <svg id="icon-twitter" xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24"><title>twitter</title><path d="M23,5.175a9.012,9.012,0,0,1-2.592.711,4.521,4.521,0,0,0,1.984-2.5,9,9,0,0,1-2.867,1.093,4.515,4.515,0,0,0-7.806,3.09A4.455,4.455,0,0,0,11.835,8.6a12.81,12.81,0,0,1-9.3-4.717,4.521,4.521,0,0,0,1.4,6.028,4.507,4.507,0,0,1-2.045-.563V9.4A4.515,4.515,0,0,0,5.505,13.83a4.4,4.4,0,0,1-1.19.159,4.5,4.5,0,0,1-.848-.079,4.516,4.516,0,0,0,4.216,3.134,9.058,9.058,0,0,1-5.6,1.932A9.266,9.266,0,0,1,1,18.914a12.781,12.781,0,0,0,6.918,2.027A12.754,12.754,0,0,0,20.759,8.1c0-.2,0-.391-.012-.583A9.146,9.146,0,0,0,23,5.175" fill="#00538b"/></svg>
                  </a>
                  <a aria-label="Follow Princess on Youtube." href="https://www.youtube.com/princesscruises" rel="noopener noreferrer">
                      <svg id="icon-youtube" xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24"><title>youtube</title><path d="M16.251,12.379,9.057,16.6V8.153Zm6.72,3.917V8.439s0-3.787-3.787-3.787H4.785S1,4.652,1,8.439V16.3s0,3.787,3.785,3.787h14.4s3.787,0,3.787-3.787" fill="#00538b"/></svg>
                  </a>
                  <a aria-label="Follow Princess on Instagram." href="https://www.instagram.com/princesscruises/" rel="noopener noreferrer">
                     <svg id="icon-instagram" xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" viewBox="0 0 24 24"><title>instagram</title><path d="M12.032,2.98c2.93,0,3.278.011,4.435.064a6.029,6.029,0,0,1,2.038.378,3.394,3.394,0,0,1,1.262.821,3.4,3.4,0,0,1,.822,1.262,6.087,6.087,0,0,1,.378,2.038c.052,1.157.064,1.505.064,4.436s-.012,3.278-.064,4.435a6.081,6.081,0,0,1-.378,2.038,3.638,3.638,0,0,1-2.084,2.084,6.081,6.081,0,0,1-2.038.378c-1.157.052-1.5.064-4.435.064s-3.279-.012-4.436-.064a6.081,6.081,0,0,1-2.038-.378,3.638,3.638,0,0,1-2.084-2.084A6.081,6.081,0,0,1,3.1,16.414c-.052-1.157-.064-1.5-.064-4.435S3.044,8.7,3.1,7.543a6.087,6.087,0,0,1,.378-2.038A3.4,3.4,0,0,1,4.3,4.243a3.394,3.394,0,0,1,1.262-.821A6.029,6.029,0,0,1,7.6,3.044C8.753,2.991,9.1,2.98,12.032,2.98m0-1.978c-2.982,0-3.355.012-4.526.066a8.057,8.057,0,0,0-2.665.51A5.385,5.385,0,0,0,2.9,2.844,5.381,5.381,0,0,0,1.631,4.788a8.063,8.063,0,0,0-.51,2.665C1.067,8.624,1.055,9,1.055,11.979s.012,3.355.066,4.525a8.057,8.057,0,0,0,.51,2.665A5.372,5.372,0,0,0,2.9,21.113a5.372,5.372,0,0,0,1.944,1.266,8.031,8.031,0,0,0,2.665.51c1.171.054,1.544.066,4.526.066s3.354-.012,4.525-.066a8.031,8.031,0,0,0,2.665-.51,5.613,5.613,0,0,0,3.21-3.21,8.057,8.057,0,0,0,.51-2.665c.054-1.17.066-1.544.066-4.525S23,8.624,22.942,7.453a8.063,8.063,0,0,0-.51-2.665,5.613,5.613,0,0,0-3.21-3.21,8.057,8.057,0,0,0-2.665-.51C15.386,1.014,15.013,1,12.032,1Z" fill="#00538b"/><path d="M12.032,6.342a5.637,5.637,0,1,0,5.636,5.637A5.637,5.637,0,0,0,12.032,6.342Zm0,9.3a3.659,3.659,0,1,1,3.658-3.659A3.659,3.659,0,0,1,12.032,15.638Z" fill="#00538b"/><circle cx="17.891" cy="6.119" r="1.317" fill="#00538b"/></svg>
                  </a>
              </div>
          </div>
      `;
  }

  createCopyRightLinks(linkItem) {
      const attributes = [`data-${this.locale}-url`, `data-${this.locale}-text`];
      const attributesData = window.getAttributesFromLink(linkItem?.localizedLink, attributes);
      return /*html*/`
          ${attributesData[0] ? `
              <li class="footer__utility-links-list--item">
                  <a class="footer__utility-links-list--link invert-decoration" 
                      data-track="footer"
                      data-track-id="${window.convertStringToKebabCase(linkItem.title)}"
                      ${linkItem?.localizedLink || ''}
                      href="${attributesData[0] || linkItem.url}">
                          ${attributesData[1] || linkItem.title}
                  </a>
               </li>`
          : `
              <li class="footer__utility-links-list--item ${linkItem?.styleClass}">
                  <a class="footer__utility-links-list--link invert-decoration" 
                      data-track="footer" 
                      data-track-id="${window.convertStringToKebabCase(linkItem.title)}" 
                      ${linkItem?.localizedLink || ''}
                      href="${linkItem.url}">
                          ${linkItem.title}
                  </a>
              </li>
          `
      }
      `;
  }

  isLocaleIn() {
      return this.locale.toLowerCase() == 'in';
  }

  createUKCopyright() {
      return `
          <div class="footer__utility-links-copyright-section">
              <div class=""> 
              Book with Confidence 
                  <svg viewBox="0 0 24 8" id="logo-abta"><title>abta</title><path d="M13.763,6.7H12.179V1.707h1.56A1.337,1.337,0,0,1,15.209,3a1.119,1.119,0,0,1-.6,1.038v.015a1.094,1.094,0,0,1,.923,1.136A1.561,1.561,0,0,1,13.763,6.7ZM13.611,2.48H13.1v1.3h.485a.663.663,0,0,0,.712-.682A.61.61,0,0,0,13.611,2.48Zm.174,2.067H13.1V5.926h.584c.613,0,.916-.274.916-.727C14.6,4.812,14.3,4.547,13.785,4.547Z"></path><path d="M19.211,2.472h-1.33V6.7h-.924V2.472H15.511V1.707h4Z"></path><path d="M10.785,6.7l-.494-1.251H8.51L8.048,6.7H7.13L9.061,1.705h.687l2,4.993ZM9.6,3.551a4.974,4.974,0,0,1-.189-.62H9.4a3.946,3.946,0,0,1-.182.606L8.791,4.7h1.214Z"></path><path d="M22.219,6.7l-.493-1.251H19.944L19.482,6.7h-.918L20.5,1.705h.687l2,4.993ZM21.037,3.551a5.184,5.184,0,0,1-.19-.62h-.008a3.946,3.946,0,0,1-.182.606L20.225,4.7h1.214Z"></path><path d="M4.045,1.028c-.095,0-.189,0-.282.014v.485h0v5.33h0v.19c.093.009.187.014.282.014a3.017,3.017,0,0,0,0-6.033Zm1.1,3.292a4.124,4.124,0,0,1-.075.563H4.366V4.32Zm-.782-.563V3.193h.7a4.139,4.139,0,0,1,.077.564Zm1.375.563h.707a2.406,2.406,0,0,1-.132.563H5.665A4.124,4.124,0,0,0,5.741,4.32Zm0-.563a3.989,3.989,0,0,0-.079-.564h.65a2.446,2.446,0,0,1,.136.564ZM6.008,2.63H5.5a3.653,3.653,0,0,0-.384-.756A2.423,2.423,0,0,1,6.008,2.63Zm-1.1,0H4.366V1.648A3.663,3.663,0,0,1,4.908,2.63ZM4.366,6.443v-1h.547a3.64,3.64,0,0,1-.546,1Zm.754-.231a3.687,3.687,0,0,0,.385-.766h.512A2.433,2.433,0,0,1,5.12,6.212Z"></path><path d="M3.477,3.476V3.247L2.033,1.8c-.08.072-.157.148-.229.227L3.25,3.476Z"></path><path d="M3.477,4.6v.229L2.033,6.271c-.08-.073-.157-.149-.229-.229L3.25,4.6Z"></path><path d="M3.477,3.764H1.042c-.009.092-.014.186-.014.28s0,.189.014.281H3.477Z"></path><path d="M1.646,2.222a2.992,2.992,0,0,0-.558,1.254H2.9Z"></path><path d="M3.477,2.9V1.087a2.985,2.985,0,0,0-1.253.557Z"></path><path d="M2.225,6.429a2.989,2.989,0,0,0,1.252.558V5.176Z"></path><path d="M2.9,4.6H1.088a3,3,0,0,0,.558,1.254Z"></path></svg>
                  <svg viewBox="0 0 24 15" id="logo-clia"><title>CLIA</title><path d="M11.342,7.3h1.619v6.477H11.342Z"></path><path d="M6.846,7.3H8.465v5.113h2.529v1.364H6.846Z"></path><path d="M5.412,9.412a1.427,1.427,0,0,0-1.3-.943c-.863,0-1.551.582-1.551,1.992,0,.917.37,1.993,1.6,1.993a1.532,1.532,0,0,0,1.287-.882l1.243.6a2.914,2.914,0,0,1-2.53,1.6A3.133,3.133,0,0,1,.987,10.461a3.061,3.061,0,0,1,3.05-3.314,2.833,2.833,0,0,1,2.627,1.64Z"></path><polygon points="15.484 7.299 13.503 7.299 13.498 13.77 15.118 13.77 15.123 9.639 17.983 13.792 20.235 13.79 15.484 7.299"></polygon><path d="M6.4,5.178a19.962,19.962,0,0,1,1.856-1.8c.362-.306.749-.615,1.192-.926.222-.156.454-.312.709-.467s.528-.312.839-.463a5.967,5.967,0,0,1,1.073-.41,3.449,3.449,0,0,1,.593-.106,1.744,1.744,0,0,1,.472.019.606.606,0,0,1,.442.271.433.433,0,0,1,.056.184.555.555,0,0,1-.02.2c-.027.01-.108-.6-1.536-.195A10.75,10.75,0,0,0,8.526,3.454,24.29,24.29,0,0,0,5.185,6.645C5.164,6.648,5.869,5.764,6.4,5.178Z"></path><path d="M5.431,5.088a12.048,12.048,0,0,1,.883-1.3c.18-.229.375-.465.606-.711.115-.123.236-.249.373-.378s.284-.263.456-.4a4.348,4.348,0,0,1,.613-.414,2.6,2.6,0,0,1,.359-.165,1.371,1.371,0,0,1,.3-.076.415.415,0,0,1,.323.063.246.246,0,0,1,.066.088.269.269,0,0,1,.019.112c-.015.01-.285-.168-1.051.254A6.81,6.81,0,0,0,6.506,3.808,20.179,20.179,0,0,0,4.653,6.531C4.64,6.536,5.19,5.5,5.431,5.088Z"></path><path d="M7.174,5.559a28.716,28.716,0,0,1,2.809-1.85c.535-.307,1.1-.613,1.741-.912.319-.15.651-.3,1.011-.442s.745-.285,1.173-.415a8.358,8.358,0,0,1,1.447-.311,4.781,4.781,0,0,1,.766-.027,2.191,2.191,0,0,1,.582.1.674.674,0,0,1,.473.4.517.517,0,0,1,.018.231.676.676,0,0,1-.082.241c-.036.007.045-.625-1.841-.381a15.441,15.441,0,0,0-4.945,1.558A26.474,26.474,0,0,0,5.5,6.952,19.533,19.533,0,0,1,7.174,5.559Z"></path><path d="M17.043,9.214l.452.607a32.575,32.575,0,0,0,5.4-5.917,8.324,8.324,0,0,0-3.167-.679C13,3,5.847,7.229,5.847,7.229a19.791,19.791,0,0,1,9.066-2.448,6,6,0,0,1,2.41.4,1.546,1.546,0,0,1,.74,1.968A7.227,7.227,0,0,1,17.043,9.214Z"></path><polygon points="15.794 10.832 15.981 11.109 15.251 11.694 15.251 11.445 15.794 10.832"></polygon><path d="M5.847,7.229a26.7,26.7,0,0,1,3.831-1.6V5.522l-.349.109L8.92,5.78l-.979.365-1.017.5Z"></path></svg>
                  <svg viewBox="0 0 24 24" id="logo-atol"><title>ATOL</title><path d="M16.3,13.569a4.546,4.546,0,0,1-3.776-2.527c-1.731-3.448,1.87-5.3,1.87-5.3l3.2.568Z"></path><polygon points="8.421 14.408 8.961 14.505 8.771 14.036 8.421 14.408"></polygon><path d="M11.219,12.251a5.748,5.748,0,0,1-.8-7.2L8.665,4.739,6.707,15.848l8.907,1.569.59-3.32A6.358,6.358,0,0,1,11.219,12.251ZM9.15,14.956l-.1-.244-.785-.14-.183.194-.463-.082.947-.937.5.089.561,1.206Zm2.449-.475-.635-.113-.157.882-.447-.079.157-.882-.638-.113.034-.19,1.72.3ZM13.353,15.6a1.564,1.564,0,0,1-.718,0,1.565,1.565,0,0,1-.673-.249.49.49,0,0,1-.245-.5.482.482,0,0,1,.4-.385,1.553,1.553,0,0,1,.718,0,1.552,1.552,0,0,1,.673.248.481.481,0,0,1,.243.5A.489.489,0,0,1,13.353,15.6Zm2.138.478L14,15.817l.19-1.072.444.079-.157.879,1.052.187Z"></path><path d="M12.8,14.662a.791.791,0,0,0-.438.023.331.331,0,0,0-.1.558.8.8,0,0,0,.4.173.787.787,0,0,0,.435-.023.335.335,0,0,0,.1-.559A.784.784,0,0,0,12.8,14.662Z"></path><path d="M1.209,10.153A10.979,10.979,0,1,0,13.927,1.248,10.991,10.991,0,0,0,1.209,10.153Zm9.029,12.019a10.269,10.269,0,1,1,11.9-8.33h0A10.28,10.28,0,0,1,10.238,22.172Zm12.594-8.207Z"></path><path d="M2.605,14.426c-.016-.084-.028-.167-.051-.249s-.054-.16-.082-.239L4.7,13.33l.218.8c.123.452.008.745-.36.846-.578.158-.817-.231-.977-.816Zm1.157-.316a1.246,1.246,0,0,0,.081.208.431.431,0,0,0,.521.169c.26-.071.4-.251.35-.421l-.055-.2Z"></path><path d="M5.249,15.128l.364.619a1.348,1.348,0,0,1,.218.5.5.5,0,0,1-.267.5.6.6,0,0,1-.789-.146c-.186.324-.347.661-.515.994l-.114.219c-.045-.091-.087-.183-.14-.273s-.111-.169-.168-.253l.407-.7c.053-.09.139-.25.211-.378l-.011-.021-.933.548c-.037-.076-.071-.154-.114-.227s-.094-.14-.142-.209Zm-.679.985a.425.425,0,0,0,.683.212.9.9,0,0,0,.137-.1c.213-.188.062-.392-.042-.569Z"></path><path d="M5.576,19.375a1.137,1.137,0,0,1-.145-1.726,1.21,1.21,0,0,1,1.8-.038,1.14,1.14,0,0,1,.148,1.723A1.226,1.226,0,0,1,5.576,19.375Zm.211-1.284a.779.779,0,0,0-.065,1.143c.39.342.907.1,1.276-.316a.813.813,0,0,0,.082-1.169C6.728,17.441,6.284,17.523,5.787,18.091Z"></path><path d="M8.4,21.069c-.075-.039-.148-.082-.225-.116s-.159-.057-.239-.085l.823-1.9a4.528,4.528,0,0,0-.594-.206,1.036,1.036,0,0,0,.073-.126,1.075,1.075,0,0,0,.04-.137l1.593.689a1.1,1.1,0,0,0-.072.123,1.111,1.111,0,0,0-.042.14,5.034,5.034,0,0,0-.535-.283Z"></path><path d="M11.48,19.466a.618.618,0,0,0-.048.286,4.764,4.764,0,0,0-.76-.177l-.121.714.346.059a3.072,3.072,0,0,0,.413.039,1.051,1.051,0,0,0-.04.14,1.013,1.013,0,0,0-.008.146,3.065,3.065,0,0,0-.4-.1l-.345-.059-.143.844a6.325,6.325,0,0,0,.775.084,1.124,1.124,0,0,0-.041.14,1,1,0,0,0-.007.145l-1.266-.214.384-2.263Z"></path><path d="M13.892,21.237l-.045.3a1.482,1.482,0,0,1-.65.209,1.156,1.156,0,0,1-1.371-1.008,1.216,1.216,0,0,1,1.211-1.4,1.5,1.5,0,0,1,.7.1c-.019.117-.028.233-.043.353l-.047,0a.7.7,0,0,0-.587-.254c-.557.054-.73.609-.682,1.1.056.573.376.948.893.9a.947.947,0,0,0,.576-.309Z"></path><path d="M15.8,21c-.081.025-.163.046-.242.077s-.153.071-.229.108l-.757-1.929a4.651,4.651,0,0,0-.566.273.608.608,0,0,0-.105-.267l1.616-.633a.92.92,0,0,0,.036.137.983.983,0,0,0,.068.129,5.173,5.173,0,0,0-.578.176Z"></path><path d="M16.858,17.7a1.052,1.052,0,0,0,.069.128,1.111,1.111,0,0,0,.1.108,4.837,4.837,0,0,0-.664.41l.418.592.286-.2a3.056,3.056,0,0,0,.322-.263,1.052,1.052,0,0,0,.069.128,1,1,0,0,0,.1.109,2.949,2.949,0,0,0-.357.214l-.286.2.493.7a6.293,6.293,0,0,0,.609-.487,1.219,1.219,0,0,0,.07.128,1,1,0,0,0,.1.109l-1.049.74-1.322-1.876Z"></path><path d="M17.907,16.538a.994.994,0,0,1,1.479-.127,1.157,1.157,0,0,1,.191,1.714l-.585.74-1.8-1.423Zm1.245,1.809.178-.224c.288-.365.325-.787-.293-1.276-.5-.392-.879-.312-1.173.061l-.205.259Z"></path><path d="M11.576,3.193l-.416-.026a.322.322,0,0,0-.045-.2.23.23,0,0,0-.154-.089.28.28,0,0,0-.248.081,1.027,1.027,0,0,0-.2.48.5.5,0,0,1,.426-.118.612.612,0,0,1,.417.282.739.739,0,0,1,.1.553.761.761,0,0,1-.294.508.736.736,0,0,1-1.05-.242,1.364,1.364,0,0,1-.064-.888,1.386,1.386,0,0,1,.378-.834.732.732,0,0,1,.629-.164.621.621,0,0,1,.391.214A.663.663,0,0,1,11.576,3.193Zm-1.12.753a.488.488,0,0,0,.039.335.286.286,0,0,0,.2.15.253.253,0,0,0,.212-.058.464.464,0,0,0,.131-.286.5.5,0,0,0-.027-.33.273.273,0,0,0-.194-.137.265.265,0,0,0-.223.059A.414.414,0,0,0,10.456,3.946Z"></path><path d="M13.059,4.766l-.069.392L11.51,4.9a1.021,1.021,0,0,1,.219-.4,2.829,2.829,0,0,1,.568-.445,2.862,2.862,0,0,0,.413-.3.47.47,0,0,0,.133-.242.3.3,0,0,0-.037-.231.29.29,0,0,0-.2-.113.28.28,0,0,0-.225.043.409.409,0,0,0-.137.248l-.414-.116a.7.7,0,0,1,.325-.459.808.808,0,0,1,.522-.065.727.727,0,0,1,.481.266.578.578,0,0,1,.109.471.75.75,0,0,1-.1.274,1.163,1.163,0,0,1-.218.252,2.729,2.729,0,0,1-.327.232c-.155.1-.253.165-.3.2a.754.754,0,0,0-.107.1Z"></path><path d="M13.375,4.7l.416.027a.309.309,0,0,0,.046.2.237.237,0,0,0,.155.09.28.28,0,0,0,.245-.081,1.032,1.032,0,0,0,.2-.479.5.5,0,0,1-.43.115.6.6,0,0,1-.413-.28.737.737,0,0,1-.1-.555A.754.754,0,0,1,13.8,3.23a.734.734,0,0,1,1.048.241,1.358,1.358,0,0,1,.064.891,1.374,1.374,0,0,1-.377.832.73.73,0,0,1-.631.164.632.632,0,0,1-.394-.21A.675.675,0,0,1,13.375,4.7Zm1.118-.755a.482.482,0,0,0-.038-.334.283.283,0,0,0-.2-.151.253.253,0,0,0-.212.058.479.479,0,0,0-.131.29.5.5,0,0,0,.028.328.273.273,0,0,0,.194.137.259.259,0,0,0,.222-.06A.422.422,0,0,0,14.493,3.946Z"></path><path d="M15.817,5.656l.079-.443-.9-.159.065-.369,1.2-1.232.354.063-.246,1.4.275.048-.066.371L16.3,5.285l-.078.444Zm.144-.814.133-.753-.64.663Z"></path></svg>
              </div>
              <p>Princess Cruises is a member of ABTA, (membership number V8764) which means you have the benefit of ABTA’s assistance and Code of Conduct. You can use ABTA's approved Alternative Dispute Resolution (ADR) process if you have a complaint that is not resolved. For more information please see <a href="https://www.abta.com" target="_blank">www.abta.com</a>. Our cruise holidays are <a href="https://www.princess.com/legal/consumer_protection/" target="_blank">ATOL protected</a> (No. 6294). </p> © 2023, Carnival plc trading as Princess Cruises. <br> Carnival plc is a company registered in England and Wales with company number 04039524 whose registered office is at Carnival House, 100 Harbour Parade, Southampton, Hampshire, United Kingdom, SO15 1ST. VAT Number: GB761430058. All Rights Reserved. Site content may not be reproduced without express written permission. <a href="https://book.princess.com/captaincircle/customerCare.page" class="no-wrap">Contact us here.</a>
              <div class="footer__utility-links-copyright-section--one-source">
                  <a href="https://www.completecruisesolution.com/Login.aspx"
                   data-track="footer" 
                   data-track-id="OneSource Travel Agent Center">
                      <img src="${$wwwURL}/images/global/ccs_logo.png" alt="Complete Cruise Solution">
                   </a>
               </div>
          </div>
      `;
  }

  createAUNZCopyright()  {
      return `
          <div class="footer__utility-links-copyright-section">
              <div>    
                  © 2023, Princess Cruise Lines, Ltd. All Rights Reserved. 
                  Site content may not be reproduced without express written permission.
              </div>   
              <div class="footer__utility-links-copyright-section--one-source">
                  <a href="http://www.wlcl.co.nz"
                  data-track="footer" 
                  data-track-id="OneSource Travel Agent Center">
                      <img src="${$wwwURL}/images/global/WLCL.png" alt="Travel Agents: World’s Leading Cruise Lines">
                  </a>
              </div>
          </div>
      `;
  }

  createCopyright() {
      if(this.locale.toLowerCase() == 'uk') {
          return this.createUKCopyright();
      } else if (this.locale.toLowerCase() == 'au' || this.locale.toLowerCase() == 'nz') {
          return this.createAUNZCopyright();
      } else {
          return this.createGeneralCopyright();
      }
  }

  createGeneralCopyright() {
      return `
      <div class="footer__utility-links--button-section">
                      <a class="affiliates-button invert-decoration ${this.isLocaleIn() ? 'hidden' : ''}" 
                         href="${$bookURL}/affiliates/login.page">Corporate Affiliates Log In</a>
                      <div class="footer__utility-links--travel-agent-logo">
                          <a href="https://www.onesourcecruises.com/onesource/login" 
                          data-track="footer" 
                          data-track-id="OneSource Travel Agent Center">
                           <img src="${$wwwURL}/images/global/os_logo_2.svg" 
                           alt="OneSource Travel Agent Center"/>
                           </a>
                       </div>
                  </div>
                  <p class="footer__utility-links--copyright">
                      &copy; ${this.currentYear}, Princess Cruises Lines, Ltd. All Rights Reserved. Site content may not be reproduced without express written permission.
                  </p>
              </div>

      `;
  }

    /**
     * createUtilityLinks
     * return {DocumentFragment} template
     */
    createUtilityLinks(cmsUtilityLinks) {
        return `
                <div class="footer__utility-links">
                    <ul aria-label="More information section" class="footer__utility-links-list no-list-style">
                        ${cmsUtilityLinks[0].navlinks.map(
            (linkItem) =>
                this.createCopyRightLinks(linkItem)
        ).join("")}
                    </ul>
                    ${this.createCopyright()}
                </div>
  
        `;
    }
    /**
     * buildTemplate
     * return {DocumentFragment} template
     */
    buildTemplate(categories, cmsUtilityLinks) {
        /**
         * All Booking Team projects (booking engine, vertical deck plans, and affiliates portal)
         * import their own versions of these stylesheets. This logic causes multiple stylesheet adds.
         */
        const bookingProjectsUrls = ['cruise-search', 'deckPlans', 'affiliates', 'localhost'];
        const isBookingPage = this.getAttribute('booking') === 'true' ||
            bookingProjectsUrls.some(url => window.location.href.includes(url));

        // Set stylesheet paths based on booking page condition
        const pclGlobalFooterCSS = isBookingPage
            ? `${$wwwURL}/assetroot/css/global/web-components/booking/pcl-global-footer.css`
            : `${$wwwURL}/assetroot/css/global/web-components/pcl-global-footer/pcl-global-footer.css`;
        const princessNormalizeCSS = isBookingPage
            ? `${$wwwURL}/assetroot/css/global/booking/princess-normalize.css`
            : `${$wwwURL}/assetroot/css/global/princess-normalize.css`

        let template = document.createElement("template");
        template.innerHTML = /*html*/`
        <link rel="stylesheet" href="${princessNormalizeCSS}" />
        <link rel="stylesheet" href="${pclGlobalFooterCSS}" />
        ${this.createSocialIcons()}
        <div class="footer-decoration">
            <picture>
                <source srcset="/images/global/Footer-Wave-BG-top.svg" media="(min-width: 840px)" />
                <img src="/images/global/Footer-Wave-Mobile.svg" alt=""/>
            </picture>
        </div>
        <footer class="footer">
            <div class="footer-navigation">
                ${categories.map((category, index) =>
            `<div class="footer-navigation-col-container">
                        ${category.map((footerNavItem) => this.createFooterNavItem(footerNavItem)).join('')}
                        ${index === categories.length - 1 ? this.createNavAppLinks() : ''}
                    </div>`).join('')}
            </div>
            ${this.createUtilityLinks(cmsUtilityLinks)}
              </footer>
        `;

      return template;
  }
}

if (!window.customElements.get('pcl-global-footer')) {
  customElements.define("pcl-global-footer", PclGlobalFooter);
}
